import { ErrorBoundary } from "@/utils/error/ErrorBoundary.tsx";
import { componentMap, StandardProps } from "@/components/componentMap.ts";
import { groupedComponentMap } from "@/groupedComponents/groupedComponentMap.ts";
import { ComponentsOrGroups } from "@/types/types.ts";
import { noticeError } from "@/utils/newrelic/requests";

export type EntriesProps = {
  components?: ComponentsOrGroups;
  sizes: string;
} & StandardProps;

export const Entries = ({
  components,
  sizes,
  ...standardProps
}: EntriesProps) => {
  if (!components || components.length < 1) {
    return null;
  }

  return components?.map((configItem, index) => {
    if (Array.isArray(configItem)) {
      noticeError(
        `Invalid group usage. Only selected slots support rendering groups of components.`,
      );
      return null;
    }

    const Component =
      groupedComponentMap[configItem.name] || componentMap[configItem.name];
    const componentKey = `${configItem.name}-${index}`;

    return Component ? (
      <ErrorBoundary componentName={configItem.name} key={componentKey}>
        <Component
          {...standardProps}
          configProps={configItem.props}
          sizes={sizes}
        />
      </ErrorBoundary>
    ) : null;
  });
};
